import { useEffect } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Footer from "../components/Footer";
import AboutContainer from "../components/AboutContainer";
import HeroImg from "../assets/Laptop.jpeg";

const About = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <Navbar />
      <Hero
        cName="hero-mid"
        heroImg={HeroImg}
        title="About"
        heading="heading-mid"
      />
      <AboutContainer />
      <Footer />
    </>
  );
};

export default About;
